import { render, staticRenderFns } from "./studentClassBag.vue?vue&type=template&id=c90f3f5e&scoped=true&"
import script from "./studentClassBag.vue?vue&type=script&lang=js&"
export * from "./studentClassBag.vue?vue&type=script&lang=js&"
import style0 from "./studentClassBag.vue?vue&type=style&index=0&id=c90f3f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90f3f5e",
  null
  
)

export default component.exports